import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

// Reducers
import plansReducer from "./slices.js/plans/plansSlice";
import tenantsReducer from "./slices.js/tenants/tenantsSlice";
import paymentsReducer from "./slices.js/payments/paymentsSlice";
import adminsReducer from "./slices.js/admins/adminsSlice";
import rolesReducer from "./slices.js/roles/rolesSlice";
import auditLogsReducer from "./slices.js/auditLogs/auditLogsSlice";
import analyticsReducer from "./slices.js/analytics/analyticsSlice";
import staffReducer from "./slices.js/staff/staffSlice";
import promotionCouponsReducer from "./slices.js/promotioncoupons/couponSlice";
import settingsReducer from "./slices.js/settings/settingsSlice";
import generalOptionsSlice from "./slices.js/settings/generalOptionsSlice";
import AuthenticationSlice from "./slices.js/authentication/authenticationSlice";
import DiscountPromotionSlice from "./slices.js/discountmanagement/discountPromotionSlice";
import FeedBackSlice from "./slices.js/feedback/feedBackSlice";
import ReposrtSlice from "./slices.js/reports/reportsSlice";
import dashboardSlice from "./slices.js/dashboard/dashboardSlice";
// Combine all reducers
import { combineReducers } from "redux";

const rootReducer = combineReducers({
  plans: plansReducer,
  tenants: tenantsReducer,
  payments: paymentsReducer,
  admins: adminsReducer,
  roles: rolesReducer,
  auditLogs: auditLogsReducer,
  analytics: analyticsReducer,
  staff: staffReducer,
  promotionCoupons: promotionCouponsReducer,
  settings: settingsReducer,
  generalSettings: generalOptionsSlice,
  authentication: AuthenticationSlice,
  discountCoupons: DiscountPromotionSlice,
  feedbackslice: FeedBackSlice,
  reposrtSlice: ReposrtSlice,
  dashboardSlice: dashboardSlice,
});

// Persist config
const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: [
    "plans",
    "tenants",
    "payments",
    "admins",
    "roles",
    "auditLogs",
    "analytics",
    "staff",
    "promotionCoupons",
    "settings",
    "generalSettings",
    "authentication",
    "discountCoupons",
    "reposrtSlice",
    "dashboardSlice",
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
